'use strcit';

angular.module('fixedPositionModule', [])
    .controller('fixedPositionCtrl', ['$scope', '$state', '$modalInstance', 'modalDialog', 'obj', 'trsHttpService', 'type', '$filter',
        function ($scope, $state, $modalInstance, modalDialog, obj, trsHttpService, type, $filter) {
            initStatus();
            initData();

            /**
             * [initStatus description]初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.data = {
                    items: obj.items, // 页面上的元素集合，全部传入筛选出医用位置的
                    selectedArray: obj.selectedArray, // 循环出的列表数据，固定的位置在该数组的order字段内，如果没有order属性就忽略这条
                    // firstPageItems: obj.firstPageItems, // 列表第一页的所有数据
                    usedItems: [], // 已经使用的集合
                    maxNum: 50, // 可输入最大数
                    firstPageItemsLenth: obj.firstPageItemsLenth,
                    docorderpri: [], // 已置顶的稿件集合
                    docorderpriPos: '', // 置顶的稿件下标
                    // docList: obj, // 所有稿件集合
                    // numArr: [], // 存放的所有稿件的位置集合
                    // newArr: [], // 剩余的稿件位置的集合
                    numberArr: [], // 用循环生成
                };
                $scope.status = {
                };
            }

            /**
             * [initData description] 初始化数据
             * @return  {[type]}  [return description]
             */
            function initData() {
                initDropDown();
                dealPosition();
                // 讲所有的位置都重新存放在一个数组
                // dealGdPositionNum();
                // 取出两个数组中不相同的部分
                // getArrDifference($scope.data.numberArr, $scope.data.numArr);  

            }

            /**
             * [initDropDown description] 初始化下拉框
             * @return  {[type]}  [return description]
             */
            function initDropDown(){
                // var num = $scope.data.firstPageItems.length > 20 ? 20 : $scope.data.firstPageItems.length;  
                for (var i = 0;i < $scope.data.maxNum;i++){
                    $scope.data.numberArr.push({
                        name: (i + 1).toString(),
                        value: (i + 1).toString(),
                    });
                }
            }

            /**
             * [dealPosition description] 处理位置
             * @return  {[type]}  [return description]
             */
            function dealPosition(){
                $scope.data.usedItems = $scope.data.items.filter((item) => item.GDORDER !== '0'); // 选中列表中已被占用位置的稿件集合
                for (var i = 0; i < $scope.data.usedItems.length; i++) {
                    for (var j = 0; j < $scope.data.numberArr.length; j++) {
                        if ($scope.data.numberArr[j].value === $scope.data.usedItems[i].GDORDER) {
                            $scope.data.numberArr[j].GDORDER = $scope.data.usedItems[i].GDORDER; // 利用此标识隐藏已选的位置 
                            break;
                        }
                    }
                    for (var k = 0; k < $scope.data.selectedArray.length; k++) {
                        if ($scope.data.selectedArray[k].GDORDER === $scope.data.usedItems[i].GDORDER) {
                            $scope.data.selectedArray[k].order = {
                                name: $scope.data.usedItems[i].GDORDER, // 为了选中初始化的位置
                                value: $scope.data.usedItems[i].GDORDER,
                                GDORDER: $scope.data.usedItems[i].GDORDER, // 利用此标识隐藏已选的位置
                            };
                            // $scope.data.selectedArray[k].needRequest = true;// 只有被固定过位置的稿件才需要发送请求
                            break;
                        }
                    }
                }
                $scope.data.items.forEach((item) => {
                    item.order = {
                        name: item.GDORDER, 
                        value: item.GDORDER,
                        GDORDER: item.GDORDER,
                    };
                });
                $scope.data.selectedArray = $filter('unique')($scope.data.selectedArray.concat($scope.data.items), 'CHNLDOCID');
                $scope.data.selectedArray.forEach((item) => {
                    if (item.GDORDER > 0) {
                        item.needRequest = true;
                    }
                });
            }   

            /**
             * [filterOption description] 过滤选过的
             * @param   {[object]}  item  [item description] 当前选项
             * @return  {[type]}          [return description]
             */
            $scope.filterOption = function (item) {
                for (var i = 0; i < $scope.data.numberArr.length; i++) {
                    if (item.GDORDER === $scope.data.numberArr[i].value) {
                        return $scope.data.numberArr[i];
                    }
                }
            };

            /**
             * [setPosition description] 选择位置
             * @param   {[object]}  item  [item description] 位置信息
             * @return  {[type]}          [return description]
             */
            $scope.setPosition = function (item) {
                $scope.data.numberArr[item.order.value - 1].GDORDER = item.order.value;
            };

            /**
             * [cancel description]取消操作
             * @return {[type]} [description]
             */
            $scope.cancel = function () {
                $modalInstance.dismiss();
            };

            /**
             * [canceFixedPosition description] 取消固定位置
             * @param   {[object]}  item   [item description] 选择的稿件
             * @param   {[string]}  index  [index description] 稿件下标
             * @return  {[type]}           [return description]
             */
            $scope.canceFixedPosition = function(item, index) {
                modalDialog.confirmModal('取消固定位置', '确认取消固定位置', function() {
                    if (item.needRequest) { // 已经被固定了位置的
                        var params = {
                            serviceid: type === 'app' ? 'mlf_appoper' : 'mlf_websiteoper',
                            methodname: 'fixedPositionOfMeta',
                            ChannelId: $state.params.channelid,
                            ChnlDocIds: item.CHNLDOCID,
                            IsFixedPos: false,
                        };
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then((data) => {
                            modalDialog.alertType('操作成功', '', 'success', false);
                            $scope.data.selectedArray.splice(index, 1);
                            $scope.data.numberArr[item.order.GDORDER - 1].GDORDER = null;
                        });
                    } else { // 准备被固定位置的
                        $scope.data.selectedArray.splice(index, 1);
                        if (item.order){
                            $scope.data.numberArr[item.order.GDORDER - 1].GDORDER = null;
                        }
                        
                    }
                });
            };

            /**
             * [dealGdNum description]
             *
             * @return  {[type]}  [return description]
             */
            // function dealGdPositionNum() {
            //     obj.forEach((item) => {
            //         $scope.data.numArr.push(item.GDORDER > 0 ? { name: item.GDORDER, value: item.GDORDER } : { name: '请输入排序位置', value: '请输入排序位置' });
            //         // $scope.data.numArr.push(item.GDORDER > 0 ? item.GDORDER : '');
            //     });
            // }

            /**
             * [dealFixedPosition description]
             *
             * @return  {[type]}  [return description]
             */
            // function dealFixedPosition() {
            //     $scope.status.gdNumRight = true;
            //     for (var i = 0; i < $scope.data.numArr.length; i++) {
            //         for (var j = i + 1; j < $scope.data.numArr.length; j++) {
            //             if ($scope.data.numArr[i] == $scope.data.numArr[j]) {
            //                 modalDialog.alertType('操作失败', '存在稿件相同的两篇稿件', 'error', false);
            //                 $scope.status.gdNumRight = false;
            //             }
            //         }
            //     }
            // }

            /**
             * [fixPosition description] 固定位置调用方法
             * @param   {[type]}  chnlDocIds  [chnlDocIds description]
             * @param   {[type]}  orderNums   [orderNums description]
             * @return  {[type]}              [return description]
             */
            function fixPosition(chnlDocIds, orderNums) {
                var params = {
                    serviceid: type === 'app' ? 'mlf_appoper' : 'mlf_websiteoper',
                    methodname: 'fixedPositionOfMeta',
                    ChannelId: $state.params.channelid,
                    ChnlDocIds: chnlDocIds,
                    IsFixedPos: true,
                    GDOrderNums: orderNums
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then((data) => {
                    if (!data) {return;}
                    modalDialog.multiReportsAlert(data, function () {
                        $modalInstance.close();
                    });
                });
            }

            /**
             * [isConfirm description]确定操作
             * @return {Boolean} [description]
             */
            $scope.isConfirm = function () {
                var GDOrderNums = '';
                var chnlDocIds = '';
                $scope.data.selectedArray.forEach((item, index) => {
                    if (!item.order) {
                        // $scope.data.selectedArray.splice(index, 1);
                    } else {
                        GDOrderNums += `${item.order.value},`;
                        chnlDocIds += `${item.CHNLDOCID},`;
                    }
                });
                GDOrderNums = GDOrderNums.slice(0, -1);
                chnlDocIds = chnlDocIds.slice(0, -1);
                if ($scope.data.selectedArray.length === 0) {
                    $modalInstance.close();
                }
                if ($scope.data.selectedArray.length) {
                    if (!GDOrderNums || !chnlDocIds) {
                        modalDialog.alertType('操作失败', '请至少选择一条稿件固定位置', 'warning', false);
                        return;
                    }
                    fixPosition(chnlDocIds, GDOrderNums);
                }                             
            };
        },
    ]);
